import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CountryCodeService } from 'app/shared/services/country-code.service';
import { Permissions } from 'model/shared/backend-api-response/permissions';
import { RGuestMessages } from 'model/shared/backend-api-response/rguest-messages';
import { Reservation } from 'model/shared/backend-api-response/reservation';
import { RoomlistService } from 'modules/shared/legacy-bookexpress/services/RoomList.service';
import { CardProcessingService } from 'modules/shared/legacy-bookexpress/services/card-processing.service';
import { GoogleAnalyticsEventsService } from 'modules/shared/legacy-bookexpress/services/google-analytics-events.service';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { ReservationService } from 'modules/shared/legacy-bookexpress/services/reservation.service';
import { ModifyReservationsService } from 'modules/shared/services/modify-reservations.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
  private tenantId: any;
  @Input() data: any;
  iframeLoaderDisplay: boolean = false;
  rGuestBookMessages: RGuestMessages;
  rGuestBookRoutePermissions: Permissions;
  subscriptions: Subscription[] = [];
  bookButtonStatus: boolean = false;
  setIframe: boolean = false;
  iframePreloader: boolean = true;
  iFrameData: string;
  iFrameInterval: any;
  iFrameLoaded: boolean = false;
  @ViewChild('paymentIframe') paymentIframe: ElementRef;
  paymentShowHide: string = 'none';
  reservationData: Reservation;
  resGuestInfo: any;
  cardList = [];
  isExistingCardSelected = false;
  isNewCardSelected = false;
  @Output() loadStatus = new EventEmitter<boolean>();
  tokenData: any;
  newCardList = [];

  defaultCard = {
    accountNumberMasked: 'xxxxxxxxxxxxxxxx',
    cardIcon: 'creditcard',
  };
  showDefaultCard = true;
  isLoading = false;

  constructor(
    public configService: LegacyBookInitService,
    public roomService: RoomlistService,
    public CardProcessingService: CardProcessingService,
    public GoogleAnalyticsEventsService: GoogleAnalyticsEventsService,
    public countryCodeService: CountryCodeService,
    public reservationService: ReservationService,
    public toastr: ToastrService,
    public modifyResService: ModifyReservationsService
  ) {}

  ngOnInit(): void {
    this.reservationData = this.reservationService?.reservationData;
    this.resGuestInfo = this.reservationData?.guestInfo?.[0] || {};
    this.setCardList();
    this.tenantId = this.configService.gettenantId();
    this.rGuestBookRoutePermissions = this.configService?.PropertyData?.permissions;
    this.rGuestBookMessages = this.roomService?.CommonService?.PropertyData?.rGuestMessages;

    if (this.rGuestBookRoutePermissions.functionalPermissions.rGuestPayIframe) {
      // To get iFrame
      this.getNewIframe();

      this.subscriptions.push(
        interval(this.configService.irameTime * 60).subscribe((x) => {
          if (this.bookButtonStatus) {
            this.iframeLoaderDisplay = true;
          }
          this.getNewIframe();
        })
      );
    }
    this.checkforCardAdded();
  }

  checkforCardAdded() {
    if (this.modifyResService?.updatedRoom?.[0]?.cardDetails?.isNewCard && this.modifyResService?.updatedRoom?.[0]?.cardDetails?.cardInfo) {
      this.tokenData = this.modifyResService?.updatedRoom?.[0]?.cardDetails;
      this.showDefaultCard = false;
      this.selectCard('isNewCardSelected', true);
    } else {
      this.tokenData = {};
      this.selectCard('isExistingCardSelected', true);
    }
  }

  setCardList() {
    if (this.resGuestInfo?.cardLast4) {
      const cardObj = {
        cardIssuer: this.resGuestInfo?.cardTypeDesc,
        accountNumberMasked: this.resGuestInfo?.cardLast4,
        cardIcon: this.modifyResService.setCardIcon(this.resGuestInfo?.cardTypeCode),
      };
      this.cardList.push(cardObj);
    }
  }

  getNewIframe() {
    if (this.rGuestBookRoutePermissions.functionalPermissions.rGuestPayIframe) {
      this.subscriptions.push(
        this.CardProcessingService.getIframeToken(this.tenantId).subscribe(
          (result) => {
            this.iframeLoaderDisplay = false;
            if (result['Success']) {
              this.processIframe(result);
            } else {
              this.setIframe = false;
              this.iframePreloader = false;
            }
          },
          (error) => {
            console.log('There is some error with processing Credit Card.');
            this.iframeLoaderDisplay = false;
          }
        )
      );
    }
  }

  processIframe = (iFrame) => {
    const alphaThreeCoutryCode = this.countryCodeService.getCountryCode();
    const doVerifyAndLanguages =
      typeof alphaThreeCoutryCode !== 'undefined' ? this.doVerifyWithLanguages(alphaThreeCoutryCode) : this.doVerifyWithOutLanguages();
    this.iFrameData = `${iFrame.paymentIframeUrl}/pay-iframe-service/iFrame/tenants/${iFrame.tenantID}/${iFrame.clientID}?apiToken=${
      iFrame.token
    }&submit=Add Card&style=${iFrame.paymentStylesUrl}?${new Date().getTime()}${doVerifyAndLanguages}&version=2`;
    let paymentRetryCounter = this.configService.paymentRetryCounter;
    let iFrameRetried = false;
    let configServicepaymentRetryCounter = this.configService.paymentRetryCounter;
    let configServicepaymentRetryInterval = this.configService.paymentRetryInterval;
    this.iFrameInterval = setInterval(() => {
      console.log('paymentRetryCounter is ', paymentRetryCounter);
      paymentRetryCounter = paymentRetryCounter - 1;
      if (paymentRetryCounter == 0 || this.iFrameLoaded) {
        clearInterval(this.iFrameInterval);

        if (paymentRetryCounter == 0) {
          this.setIframe = false;
          this.iframePreloader = false;
          this.GoogleAnalyticsEventsService.eventEmitter(
            'load_iFrame',
            'room',
            'iFrame_load_error',
            'iFrame Load Error at : ' + (configServicepaymentRetryCounter - paymentRetryCounter) + ' attempt'
          );
        }
        if (this.iFrameLoaded) {
          this.iframePreloader = false;
          this.setIframe = true;
          if (iFrameRetried) {
            this.GoogleAnalyticsEventsService.eventEmitter(
              'load_iFrame',
              'room',
              'iFrameLoadSuccess',
              'iFrame Loaded Successfully at : ' + (configServicepaymentRetryCounter - paymentRetryCounter) + ' attempt'
            );
          }
        }
      } else {
        let hostElem = this.paymentIframe.nativeElement;
        hostElem.src = this.iFrameData;
        this.GoogleAnalyticsEventsService.eventEmitter(
          'load_iFrame',
          'room',
          'iFrame_load_error',
          'iFrame Load Error at : ' + (configServicepaymentRetryCounter - paymentRetryCounter) + ' attempt'
        );
        iFrameRetried = true;
      }
    }, configServicepaymentRetryInterval);
  };

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  doVerifyWithLanguages(countryCode) {
    const doVerifyalongWithLanguages = '&doVerify=true&language=' + countryCode;
    return doVerifyalongWithLanguages;
  }

  doVerifyWithOutLanguages() {
    const onlyDoVerify = '&doVerify=true';
    return onlyDoVerify;
  }

  selectCard(key, value) {
    this[key] = value;
    const otherKey = key === 'isExistingCardSelected' ? 'isNewCardSelected' : 'isExistingCardSelected';
    this[otherKey] = !value;
    if (this.modifyResService?.updatedRoom?.length) {
      if (this.isNewCardSelected) {
        this.modifyResService.updatedRoom[0].cardDetails = { ...this.tokenData, isNewCard: true };
      } else {
        this.modifyResService.updatedRoom[0].cardDetails = {
          cardLast4: this.resGuestInfo?.cardLast4,
          cardTypeDesc: this.resGuestInfo?.cardTypeDesc,
          cardTypeCode: this.resGuestInfo?.cardTypeCode,
          cardIcon: this.modifyResService.setCardIcon(this.resGuestInfo?.cardTypeCode),
          isNewCard: false,
        };
      }
    }
  }

  addNewCard() {
    this.paymentShowHide = 'block';
    this.showDefaultCard = false;
    this.selectCard('isExistingCardSelected', false);
  }

  @HostListener('window:message', ['$event'])
  onMessage(ev) {
    this.receiveToken(ev);
    if (ev.data.event_id == 'iframe_loaded') {
      this.iFrameLoaded = true;
    }
  }

  receiveToken(e) {
    if (e.data.token) {
      this.loadStatus.emit(false);
      this.tokenData = e.data;
      this.tokenData.cardInfo.cardLastDig = this.tokenData?.cardInfo?.accountNumberMasked?.slice(-4) || '';
      if (this.tokenData?.cardInfo?.cardIssuer) {
        this.tokenData.cardInfo.cardIcon = this.modifyResService.setCardIcon(this.tokenData.cardInfo.cardIssuer);
      }
      this.paymentShowHide = 'none';
      this.showDefaultCard = false;
      this.isLoading = false;
      this.selectCard('isNewCardSelected', true);
    } else {
      if (e.data.event_id == 'iframe_validationerror') {
        this.isLoading = false;
        this.loadStatus.emit(false);
        return false;
      }
      if (typeof e.data == 'string' && e.data != '') {
        this.isLoading = false;
        this.loadStatus.emit(false);
        var errorData = [];
        try {
          errorData = JSON.parse(e.data);
        } catch (err) {
          errorData = e.data;
        }

        if (errorData['validationErrors']) {
          console.log(errorData['validationErrors']);
          if (errorData['validationErrors'].length > 0) {
            let errorText = '';
            for (let i = 0; i < errorData['validationErrors'].length; i++) {
              errorText += errorData['validationErrors'][i].fieldName + ' ' + errorData['validationErrors'][i].value + '. ';
            }
            this.toastr.error(errorText);
            return false;
          } else {
            this.toastr.error('Something went wrong ! Please refresh the page and try again.');
            return false;
          }
        } else if (errorData['message']) {
          this.toastr.error(errorData['message']);
          return false;
        }
      }
    }
  }

  removeNewCard() {
    this.getNewIframe();
    this.tokenData = {};
    this.showDefaultCard = true;
    this.selectCard('isExistingCardSelected', true);
  }
}
